<script lang="ts">

    import LastmileFilter from "../../shared/LastmileFilter.svelte";
    import {filter} from "../../../stores/filter";
    import {jobs_filter_config} from "../../../stores/api";
    import type { QuickFilterType } from "../../shared/QuickFilter.svelte";

    export let filteredCount: number = 0;
    export let totalCount: number = 0;
    export let makeBlured: boolean = false;
    export let quickFilters: QuickFilterType[] = [];
    export let onQuickFilterSwitch: (index: number, active: boolean) => void = (index: number, active: boolean) => {};

</script>

<LastmileFilter
        collectionName="jobs"
        onChange={(queries)=>{ $filter.jobsToBeCompleted.queries = queries; }}
        showQuickFilters={false}
        filterConfig={$jobs_filter_config}
        enableInactiveQueries={true}
        filterManagerStorageKey={ $filter.jobsToBeCompleted.managerStorageKey }
        {filteredCount}
        {totalCount}
        {makeBlured}
        {quickFilters}
        {onQuickFilterSwitch}
/>
